





















































































































































































































































































import { Vue, Component } from 'vue-property-decorator'

@Component
export default class WhichProgrammingLanguage extends Vue {
  get codeSnippet1 () {
    return `# Python is a weakly typed language. You can change strings (characters/words) to numbers and multiply them.

aWord = 'Hello'
x = aWord*2 # No error
aWord = 123 # No error, possible to turn strings into numbers`
  }

  get codeSnippet2 () {
    return `// Java is a strongly typed language; you cannot change types of variables.

string aWord = "Hello";
int x = aWord * 2; // Error can't multiply string by integer
aWord = 123; // Also error`
  }
}
